const productCategory = [
    { id : 1, label : "Airpodes", value : "airpodes"},
    { id : 2, label : "Camera", value : "camera"},
    { id : 3, label : "Earphones", value : "earphones"},
    { id : 4, label : "Mobiles", value : "mobiles"},
    { id : 5, label : "Mouse", value : "Mouse"},
    { id : 6, label : "Printers", value : "printers"},
    { id : 7, label : "Processor", value : "processor"},
    { id : 8, label : "Refrigerator", value : "refrigerator"},
    { id : 9, label : "Speakers", value : "speakers"},
    { id : 10, label : "Trimmers", value : "trimmers"},
    { id : 11, label : "Televisions", value : "televisions"},
    { id : 12, label : "Watches", value : "watches"},
    { id : 13, label : "AC For Rent", value : "ac for rent"},
    { id : 14, label : "Refrigerator For Rent", value : "refrigerator for rent"},
    { id : 15, label : "Televisions For Rent", value : "televisions for rent"},
    { id : 16, label : "Microwave For Rent", value : "microwave for rent"},
    { id : 17, label : "Washingmachine For Rent", value : "Washingmachine for rent"},
]


export default productCategory